import { Box } from '@mui/material';
import { Header } from 'components/home';
import { TopNavBar } from 'components/top_nav_bar';
import { MenuProvider } from 'contexts/menu/menu_context';
import React, { useEffect, useState } from 'react';
import useCifaStore from 'stores/cifa/cifa.store';
import { ROUTES } from 'routes/constants';
import { useNavigate, useLocation } from 'react-router-dom';
import ViewSchoolFeedingAcquisitions from './ViewSchoolFeedingAcquisitions';

interface Produto {
    id: string;
    nomeRazao: string;
    documento: string;
    valor: string;
    valorNumerico: number;
    fonte: 'federal' | 'estadual' | 'municipal';
    tipoFornecedor: 'CNPJ' | 'CPF';
}

interface SecaoAquisicao {
    titulo: string;
    produtosCnpj: Produto[];
    produtosCpf: Produto[];
}

const mapProdutos = (
    fonte: 'federal' | 'estadual' | 'municipal',
    tipoFornecedor: 'CNPJ' | 'CPF',
    arr: any[] = [],
): Produto[] =>
    arr.map((p: any, idx: number) => ({
        id: `${tipoFornecedor}-${fonte}-${idx}`,
        nomeRazao: p.nome_razao_social,
        documento: tipoFornecedor === 'CNPJ' ? p.cnpj : p.cpf,
        valor: p.valor?.toString() ?? '',
        valorNumerico: Number(p.valor) || 0,
        fonte,
        tipoFornecedor,
    }));

const ViewSchoolFeedingAcquisitionsPage: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { cifa } = useCifaStore();
    const [secoes, setSecoes] = useState<SecaoAquisicao[]>([
        {
            titulo: 'Recursos do PNAE/Federal',
            produtosCnpj: [],
            produtosCpf: [],
        },
        {
            titulo: 'Recursos do Governo do Estado',
            produtosCnpj: [],
            produtosCpf: [],
        },
        {
            titulo: 'Recursos da Prefeitura',
            produtosCnpj: [],
            produtosCpf: [],
        },
    ]);

    // Extrai o ano da rota, ex: /service_management/cifa-2027 => 2027
    const match = /cifa-(\d{4})/.exec(location.pathname);
    const anoReferencia = match ? Number(match[1]) : 2026;

    useEffect(() => {
        if (!cifa.uuid) {
            navigate(ROUTES[`CIFA${anoReferencia}` as keyof typeof ROUTES] as string);
            return;
        }

        setSecoes([
            {
                titulo: 'Recursos do PNAE/Federal',
                produtosCnpj: mapProdutos(
                    'federal',
                    'CNPJ',
                    cifa.aquisicoes_pnae_federal_detalhamento?.cnpj,
                ),
                produtosCpf: mapProdutos(
                    'federal',
                    'CPF',
                    cifa.aquisicoes_pnae_federal_detalhamento?.cpf
                ),
            },
            {
                titulo: 'Recursos do Governo do Estado',
                produtosCnpj: mapProdutos(
                    'estadual',
                    'CNPJ',
                    cifa.aquisicoes_governo_estado_detalhamento?.cnpj,
                ),
                produtosCpf: mapProdutos(
                    'estadual',
                    'CPF',
                    cifa.aquisicoes_governo_estado_detalhamento?.cpf,
                ),
            },
            {
                titulo: 'Recursos da Prefeitura',
                produtosCnpj: mapProdutos(
                    'municipal',
                    'CNPJ',
                    cifa.aquisicoes_prefeitura_detalhamento?.cnpj,
                ),
                produtosCpf: mapProdutos(
                    'municipal',
                    'CPF',
                    cifa.aquisicoes_prefeitura_detalhamento?.cpf,
                ),
            },
        ]);
    }, [cifa, navigate, anoReferencia, location.pathname]);

    return (
        <MenuProvider>
            <TopNavBar />
            <Header title={`CIFA - Visualização das Aquisições de Alimentação Escolar - ${anoReferencia}`} showBackButton={true} />
            <Box width='97%' display='flex' flexDirection='column' justifyContent='center' alignItems='center' margin='2rem'>
                <ViewSchoolFeedingAcquisitions secoes={secoes} />
            </Box>
        </MenuProvider>
    );
};

export default ViewSchoolFeedingAcquisitionsPage;
